<template>
  <timeline
    :timeline="timeline"
    :tiles="tileDetails"
    :read-only="!canEdit"
    :loading="loading"
    :default-tile-permission="permissions.canAccessClients"
    anchor="dialog-menubar"
    model-name="client"
    @add-note="(note, done) => baseAddNote(note, done, id, timeline, true)"
    @update-note="(note, done) => baseUpdateNote(note, done, true)"
    @remove-note="(entryId, reference) => baseRemoveNote(entryId, reference, true)"
    @pin-note="(entryId, val, done, reference) => basePinNote(entryId, val, done, reference, true)"
    @save-attachments="(keepIds, removeObjs, done) => baseSaveAttachments(keepIds, removeObjs, done, id, timeline, true)"
    @remove-attachment="(entryId, key, reference) => baseRemoveAttachment(entryId, key, id, reference, true)"
    @pin-attachment="(entryId, val, key, done, reference) => basePinAttachment(entryId, val, key, done, id, reference, true)"
  />
</template>

<script>
import clientTimelineMethodsMixin from 'components/app/clients/partials/mixins/clientTimelineMethodsMixin'

export default {
  mixins: [clientTimelineMethodsMixin],
  props: {
    id: {
      type: Number,
      required: true
    },
    canEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      timeline: [],
      loading: false
    }
  },
  computed: {
    tileDetails () {
      return {
        'note': 'Notes may be collated from appointments, invoices & reports',
        'attachment': true,
        'log': true,
        'communication': 'Communication Logs may be collated from appointments, invoices and reports',
        'invoice': true,
        'report': true,
        'appointment': true,
        'appointment_future': true,
        'quotation': true,
        'drawing': true
      }
    }
  },
  methods: {
    /* Get Timeline */
    async getTimeline () {
      this.loading = true
      const { status, payload } = await this.$get('v1/clients/timeline', {
        id: this.id
      })
      this.loading = false
      if (status === 'success') {
        this.timeline = payload.timeline
      }
    }
  },
  mounted () {
    this.getTimeline()
  }
}
</script>
